import sentryConfig from './sentry.js'
import Users from 'src/api/users.js'
import Core from 'src/api/core.js'
import native from 'src/config/native.js'
import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

const getLocalStorageKey = (key) => {
  const localStorageValue = localStorage && localStorage.getItem(key)
  if (localStorageValue !== null) {
    return {
      storage: 'localStorage',
      value: localStorageValue
    }
  }

  return {
    storage: 'sessionStorage',
    value: window.sessionStorage && window.sessionStorage.getItem(key)
  }
}

export default {
  async SET_SLINK ({ commit, state }, slink) {
    commit('SET_SLINK', slink)

    if (state.school) return

    try {
      const { data } = await Core.getFindSchools({ params: { slink }, bypassRefresh: true })
      if (!data) {
        return GlobalPrototypes.router.replace({ name: 'login-start' })
      }
      commit('SET_SCHOOL', data)
      commit('schoolBranding/SET_BRANDING', data)
    } catch {
      GlobalPrototypes.router.replace({ name: 'login-start' })
    }
  },
  async savePushToken ({ state }, { token = null, consentState = null } = {}) {
    const pushToken = token || GlobalPrototypes.store.state.device.firebaseToken
    const pushNotificationConsent = consentState || GlobalPrototypes.store.state.device.consent
    const device = native.getDevice()
    const userID = state.users.me_id
    const nativeVersion = await native.getVersion()
    const packageName = await native.getPackageName()

    if (!pushToken || !state.authToken || !userID) return false

    const params = {
      token: pushToken,
      push_notification_consent: pushNotificationConsent,
      type: device,
      app_version: nativeVersion,
      package_name: packageName
    }

    try {
      await Users.postDevices(state.users.me_id, params, { showMessages: false })
    } catch (error) {
      // todo: this is for debugging
      if (error.request.status !== 400) return false

      sentryConfig.addBreadcrumb({
        category: 'native_push',
        message: JSON.stringify({
          firebase: params.token,
          type: params.type,
          package_name: params.package_name
        }),
        level: 'warning'
      })

      sentryConfig.addBreadcrumb({
        category: 'native_response',
        message: JSON.stringify(error.request.data),
        level: 'warning'
      })

      sentryConfig.throwError('Device Push Token invalid')

      return false
    }

    return true
  },
  loadAuthToken ({ commit }) {
    const { storage, value } = getLocalStorageKey('auth_token')
    if (!value) return false
    commit('SET_AUTH_TOKEN', { authToken: value, stayLoggedIn: storage === 'localStorage' })

    return value
  }
}
